import { UserX, Mail, Home } from "lucide-react";
import { Button } from "@/components/atoms/button";
import { Card, CardContent } from "@/components/atoms/card";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function NotRegistered() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate("/welcome");
  };

  const handleContactSupport = () => {
    // You can customize this to your support email or contact method
    window.open(
      "mailto:soporte@gonau.com?subject=Solicitud de acceso a Tower&body=Hola, necesito acceso a la plataforma Tower.",
      "_blank",
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full">
        <Card>
          <CardContent className="pt-6">
            <div className="text-center">
              <div className="mx-auto w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                <UserX className="w-8 h-8 text-orange-600" />
              </div>

              <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                Usuario no registrado
              </h2>

              <p className="text-gray-600 mb-6">
                Tu cuenta ha sido autenticada correctamente, pero no tienes
                acceso autorizado a esta plataforma. Contacta a tu administrador
                para solicitar acceso.
              </p>

              <div className="space-y-3">
                <Button
                  onClick={handleContactSupport}
                  className="w-full flex items-center justify-center gap-2"
                >
                  <Mail className="w-4 h-4" />
                  Contactar soporte
                </Button>

                <Button
                  variant="outline"
                  onClick={handleLogout}
                  className="w-full flex items-center justify-center gap-2"
                >
                  <Home className="w-4 h-4" />
                  Cerrar sesión
                </Button>
              </div>

              <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
                <p className="text-sm text-blue-800">
                  <strong>¿Necesitas acceso?</strong>
                  <br />
                  Contacta a tu administrador de sistema con tu correo
                  electrónico para que te proporcione los permisos necesarios.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
